import { render } from "./SharesView.vue?vue&type=template&id=9465c2ce"
import script from "./SharesView.vue?vue&type=script&lang=js"
export * from "./SharesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Katongole R\\Desktop\\Projects\\Portal\\mfuko-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__